
import {defineComponent} from 'vue';
import nieuwsQuery from '~/graphql/queries/nieuws/nieuws.gql';
import {defaultPagination} from '~/utils/graphql';

export default defineComponent({
  apollo: {
    nieuws: {
      query: nieuwsQuery,
      variables: {
        limit: 3,
      },
    },
  },

  props: {
    title: {
      type: String,
      required: false,
      default: 'Gerelateerde nieuwsberichten',
    },
  },

  data: () => ({
    nieuws: defaultPagination(),
    colorCombinations: [
      {background: 'bg-orange', button: 'bg-primary'},
      {background: 'bg-primary', button: 'bg-orange'},
      {background: 'bg-blue', button: 'bg-orange'},
    ],
  }),

  methods: {
    getColorCombination(currentIndex: number) {
      return this.colorCombinations[currentIndex % this.colorCombinations.length];
    },
  },
});
